import { environment } from "@environment";
import { CountryCodes, convertTwoCharacterCountryCodeToThree } from "core/country-codes";
import { BaseService } from "core/services/tv-guide.service";
import { UrlBuilder } from "@lib-shared/lib";
import { Utils } from "core/lib/utils";
import { Channel } from "core/types";
import dateTimeWrapper from "core/lib/date-time-wrapper";

export class ChannelService extends BaseService {
  constructor() {
    super("/umbraco/api/tv-guide");
  }

  async getChannnel(channelTag: string, channelNumber: string) {
    const date = dateTimeWrapper().date;

    const culture = Utils.GetCulture().culture ?? environment.defaultLocale;
    const twoCharacterCountryCode = culture.split("-")[1];
    const countryCode = convertTwoCharacterCountryCodeToThree(twoCharacterCountryCode);

    const url = new UrlBuilder("channel")
      .appendParam("currentDate", date)
      .appendParam("country", countryCode)
      .appendParam("culture", culture);

    if (channelTag) {
      url.appendParam("channelTag", channelTag);
    }

    if (channelNumber) {
      url.appendParam("channelNumber", channelNumber);
    }

    return this.get<Channel>(url);
  }
}